import styled from 'styled-components';

import { Section } from '@hero/atoms';
import { DoubleContactTable } from '@hero/organisms';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  ${Section.S.SectionWrapper}, ${DoubleContactTable.S.Wrapper} {
    width: 100%;
  }
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
`;

export { Content, Wrapper };
